import React from 'react';
import style from './TotalsSection.module.scss';
import carImage from '@/public/images/about_us/Car.webp';
import Image from 'next/image';

export const TotalsSection = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between py-12 md:flex-row md:py-24">
      <div className={style.wrapper}>
        <div className="border-b border-[#4F4F4F] px-5 py-10 md:border-b-0 md:border-r">
          <p className="text-5xl font-semibold text-white md:text-7xl">
            1500 <span className="text-textOrange">+</span>
          </p>
          <p className="text-xl font-normal text-white md:text-2xl">
            Total Customer
          </p>
        </div>
        <div className="border-b border-[#4F4F4F] px-5 py-10">
          <p className="text-5xl font-semibold text-white md:text-7xl">
            100<span className="text-textOrange">%</span>
          </p>
          <p className="text-xl font-normal text-white md:text-2xl">
            Client Satisfaction
          </p>
        </div>
        <div className="border-b border-[#4F4F4F] px-5 py-10 md:border-b-0 md:border-r ">
          <p className="text-5xl font-semibold text-white md:text-7xl">
            50<span className="text-textOrange">+</span>
          </p>
          <p className="text-xl font-normal text-white md:text-2xl">
            Team Members
          </p>
        </div>
        <div className="px-5 py-10">
          <p className="text-5xl font-semibold text-white md:text-7xl">
            20<span className="text-textOrange">+</span>
          </p>
          <p className="text-xl font-normal text-white md:text-2xl">
            Years of experience
          </p>
        </div>
      </div>
      <div className="relative mt-10 md:ml-10 md:mt-0">
        <div className="rounded-xl bg-white px-5 py-10 md:px-20">
          <div className="right-0">
            <Image src={carImage} alt="car" />
          </div>
          <p className="mt-10 text-2xl font-semibold md:text-4xl">
            Instant Support
          </p>
        </div>
      </div>
    </div>
  );
};
